import React, { useEffect, useState } from "react";
import "./profile.scss";
import { Button, Col, Divider, Input, Row, Switch, Typography } from "antd";
import { UserChangePasswordModal } from "../../../components/userChangePasswordModal/userChangePasswordModal";
import { UserTotpEnableModal } from "../../../components/userTotpEnableModal/userTotpEnableModal";
import { UserTotpDisableModal } from "../../../components/userTotpDisableModal/userTotpDisableModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { GetMeRes } from "../../../interfaces/user.interface";
import { getMeService } from "../../../services/user.service";
import { HandleErrors } from "../../../utils/handleErrors";
import { userSlice } from "../../../redux/slices/user";
import { GetPermissionRes } from "../../../interfaces/role.interface";
import { PermissionCode } from "../../../enum/permission";

const Profile = () => {
  const dispatch = useDispatch();
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );

  const userRoleName = useSelector<RootState, string>(
    (root) => root.user.roleName
  );
  const [user, setUser] = useState<GetMeRes>({} as GetMeRes);

  useEffect(() => {
    getMe();
  }, []);

  const getMe = async () => {
    try {
      const res = await getMeService({});
      setUser(res);
      dispatch(userSlice.actions.setUser(res));
    } catch (error) {
      HandleErrors(error);
    }
  };

  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [enableTotpModal, setEnableTotpModal] = useState(false);
  const [disableTotpModal, setDisableTotpModal] = useState(false);

  return (
    <div className="Profile">
      <Row align={"middle"} justify={"space-between"} className="title-box">
        <Col>
          <Typography.Text className="title">پروفایل کاربر</Typography.Text>
        </Col>
        <Col>
          <Typography.Text className="role">
            نقش کاربری: {userRoleName}
          </Typography.Text>
        </Col>
      </Row>
      <div className="info-box">
        <Row>
          <Col>
            <Typography.Text className="title">اطلاعات کاربر</Typography.Text>
          </Col>
        </Row>
        <Divider />
        <Row justify={"space-between"} align={"middle"}>
          <Col md={11} xs={24} className="input-box">
            <Typography.Text className="title">نام: </Typography.Text>
            <Input className="input" value={user?.first_name} disabled></Input>
          </Col>
          <Col md={11} xs={24} className="input-box">
            <Typography.Text className="title">نام خانوادگی: </Typography.Text>
            <Input className="input" value={user?.last_name} disabled></Input>
          </Col>
          <Col md={11} xs={24} className="input-box">
            <Typography.Text className="title">نام کاربری: </Typography.Text>
            <Input className="input" value={user?.username} disabled></Input>
          </Col>
          <Col md={11} xs={24} className="input-box">
            <Typography.Text className="title">ایمیل: </Typography.Text>
            <Input className="input" value={user?.email} disabled></Input>
          </Col>
        </Row>
      </div>
      <div className="security-box">
        <Row>
          <Col>
            <Typography.Text className="title">تنظیمات امنیتی</Typography.Text>
          </Col>
        </Row>
        <Divider />
        <div className="password-box">
          <Row>
            <Typography.Text className="title">رمز عبور</Typography.Text>
          </Row>
          <Row align={"middle"} justify={"space-between"}>
            <Col md={19} xs={12}>
              <Input.Password className="input" disabled value={"**********"} />
            </Col>
            <Col md={4} xs={9}>
              {userPermissions.find(
                (p) => p.code === PermissionCode.userChangePassword
              ) && (
                <Button
                  //className="btn"
                  block
                  size="large"
                  type="primary"
                  onClick={() => {
                    setChangePasswordModal(true);
                  }}
                >
                  تغییر رمز عبور
                </Button>
              )}
            </Col>
          </Row>
        </div>
        <div className="totp-box">
          <Row align={"middle"} justify={"space-between"}>
            <Col>
              <Typography.Text className="title">
                ورود دو مرحله‌ای
              </Typography.Text>
            </Col>
            <Col>
              <Switch checked={user?.totp_enable} disabled />
            </Col>
          </Row>
          <Row
            align={"middle"}
            justify={"space-between"}
            style={{
              marginTop: 15,
            }}
          >
            <Col md={12} xs={24}>
              <Typography.Text className="text">
                برنامه‌ Authenticator با ایجاد کدهای یکبار مصرف، امنیت حساب
                کاربری شما را افزایش می‌دهد و از آن در برابر حملات فیشینگ و سرقت
                رمز محافظت می‌کند.
              </Typography.Text>
            </Col>
            <Col md={4} xs={24}>
              {!user?.totp_enable &&
                userPermissions.find(
                  (p) => p.code === PermissionCode.userEnableTotp
                ) && (
                  <Button
                    //className="btn"
                    block
                    size="large"
                    type="primary"
                    onClick={() => {
                      setEnableTotpModal(true);
                    }}
                  >
                    <span>ایجاد OTP</span>
                  </Button>
                )}
              {user?.totp_enable && userPermissions.find(
                (p) => p.code === PermissionCode.userDisableTotp
              ) &&(
                <Button
                  //className="btn"
                  block
                  size="large"
                  type="primary"
                  onClick={() => {
                    setDisableTotpModal(true);
                  }}
                >
                  <span>حذف OTP</span>
                </Button>
              )}
            </Col>
          </Row>
        </div>
      </div>

      <UserChangePasswordModal
        show={changePasswordModal}
        onClose={() => {
          setChangePasswordModal(false);
        }}
      />
      <UserTotpEnableModal
        show={enableTotpModal}
        onClose={() => {
          setEnableTotpModal(false);
          getMe();
        }}
      />
      <UserTotpDisableModal
        show={disableTotpModal}
        onClose={() => {
          setDisableTotpModal(false);
          getMe();
        }}
      />
    </div>
  );
};

export default Profile;
